"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reactRedux = require("react-redux");

var _Auth = require("FileManagerCore/selectors/Auth");

var _logging = require("FileManagerCore/utils/logging");

var _FoldersAndFiles = _interopRequireDefault(require("../../components/browser/FoldersAndFiles"));

var _Files = require("../../actions/Files");

var _Actions = require("../../actions/Actions");

var _UploadingFiles = require("FileManagerCore/selectors/UploadingFiles");

var _Permissions = require("FileManagerCore/selectors/Permissions");

var _Panel = require("../../selectors/Panel");

var _Configuration = require("../../selectors/Configuration");

var _Limits = require("../../selectors/Limits");

var mapStateToProps = function mapStateToProps(state, props) {
  return {
    selectedFolder: (0, _Panel.getSelectedFolderInPanel)(state),
    selectedFileId: (0, _Panel.getSelectedFileId)(state),
    uploadingFiles: (0, _UploadingFiles.getUploadingFiles)(state),
    isReadOnly: (0, _Permissions.getIsReadOnly)(state),
    disableUpload: props.disableUpload || (0, _Limits.getIsHublPanelOpenAndUserOverEmbeddableVideoLimit)(state, props),
    isHostAppContextPrivate: (0, _Configuration.getIsHostAppContextPrivate)(state),
    isUngatedForPreviewThumbnails: (0, _Auth.getIsUngatedForPreviewThumbnails)(state)
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onSelectFolder: function onSelectFolder(folder) {
      dispatch((0, _Actions.maybeFetchFoldersByParentId)(folder.get('id')));
      dispatch((0, _Actions.browseToFolder)(folder.get('id')));
    },
    onSelectFile: function onSelectFile(file, meta) {
      dispatch(file ? (0, _Actions.selectFile)(file, meta) : (0, _Actions.deselectFile)(meta));
    },
    onDropFiles: function onDropFiles(files, folder, type) {
      var options = {
        folderId: folder.get('id'),
        type: type
      };
      dispatch((0, _Files.uploadFiles)(files, options));
      dispatch((0, _Actions.maybeFetchFoldersByParentId)(folder.get('id')));
      dispatch((0, _Actions.browseToFolder)(folder.get('id')));
      dispatch((0, _Actions.trackInteraction)('Manage Files', 'drag-and-dropped-file', {
        target: 'folder'
      }));
      (0, _logging.logNewRelicPageAction)('dropFiles', {
        componentName: 'Drawer',
        target: 'folder-drop-target',
        drawerType: type
      });
    }
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_FoldersAndFiles.default);

exports.default = _default;
module.exports = exports.default;